module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('navbar'), _vm._v("\n  This URL is in use for Andrea van Leerdam's PhD research project, 'Woodcuts as reading aids: Illustrations and knowledge transfer in printed books in Dutch on the natural world, c. 1480 - c. 1550', at Utrecht University, the Netherlands.\n  More information: "), _c('a', {
    attrs: {
      "href": "http://www.uu.nl/staff/aevanleerdam",
      "target": "_blank"
    }
  }, [_vm._v("www.uu.nl/staff/aevanleerdam")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b59a558","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 244
// module chunks = 1